import { Flex, Select, Text, Button } from "@chakra-ui/react";
import { useState } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useDispatch } from "react-redux";

const PAGE_OPTIONS = [5, 10, 20, 50, 100];

const TablePaginator = ({
  limit,
  totalPages,
  totalDocs,
  page,
  hasPrevPage,
  hasNextPage,
  prevPage,
  nextPage,
  listProducts,
  searchTerm,
}) => {
  const [usingLimit, setUsingLimit] = useState(limit);
  const dispatch = useDispatch();

  const handleChangeLimit = (value) => {
    setUsingLimit(value);
    const query = {
      limit: value,
      page: 1,
      name: searchTerm,
      description: searchTerm,
    };
    dispatch(listProducts(query));
  };

  const nextPageHandler = () => {
    const query = {
      limit: usingLimit,
      page: nextPage,
      name: searchTerm,
      description: searchTerm,
    };
    dispatch(listProducts(query));
  };

  const prevPageHandler = () => {
    const query = {
      limit: usingLimit,
      page: prevPage,
      name: searchTerm,
      description: searchTerm,
    };
    dispatch(listProducts(query));
  };

  return (
    <Flex w="100%" alignItems="center" flexDir="row" justifyContent='space-between'>
    <Flex>
        <Text mr="10px">Total {totalDocs} elementos</Text>
    </Flex>
      <Flex alignItems="center">
        <Flex justifyContent={"center"} alignItems={"center"}>
          <Text mr="10px">Mostrando</Text>
          <Select
            value={"" + usingLimit}
            onChange={(e) => {
              handleChangeLimit(e.target.value);
            }}
          >
            {PAGE_OPTIONS.map((option) => (
                <option key={option} value={option}>
                    {option}
                </option>
            ))}
          </Select>
        </Flex>
        <Flex mx="25px">
          {page} / {totalPages}
        </Flex>
        <Flex>
          <Button
            variant="ghost"
            disabled={!hasPrevPage}
            onClick={prevPageHandler}
          >
            <BsChevronLeft />
          </Button>
          <Button
            variant="ghost"
            disabled={!hasNextPage}
            onClick={nextPageHandler}
          >
            <BsChevronRight />
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default TablePaginator;
